import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import UndoOutlinedIcon from '@mui/icons-material/UndoOutlined';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import NotesOutlinedIcon from '@mui/icons-material/NotesOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';

const rawMenuItems = [
  {
    title: "Dashboard",
    icon: HomeOutlinedIcon,
    href: "/DepositPortal/dashboard",
    moduleKey: "Dashboard",
  },
  {
    title: "Sub Merchant",
    icon: GroupAddOutlinedIcon,
    href: "/DepositPortal/sub_merchant",
    moduleKey: "Sub Merchant",
  },
  {
    title: "Deposits",
    icon: SavingsOutlinedIcon,
    href: "/DepositPortal/merchant_deposits",
    moduleKey: "Deposits",
  },
  {
    title: "Test Deposits",
    icon: SendOutlinedIcon,
    href: "/DepositPortal/merchant_test_deposits",
    moduleKey: "Deposits",
  },
  {
    title: "Chargebacks & Refunds",
    icon: UndoOutlinedIcon,
    href: "/DepositPortal/refund_chargebacks",
    moduleKey: "Refunds & Chargebacks",
  },
  {
    title: "Settlement",
    icon: CompareArrowsOutlinedIcon,
    moduleKey: "Settlements",
    children: [
      {
        title: "Local",
        href: "/DepositPortal/local_settlements",
        moduleKey: "Settlements",
      },
      {
        title: "International",
        href: "/DepositPortal/international_settlements",
        moduleKey: "Settlements",
      },
    ],
  },
  {
    title: "Reports",
    icon: BarChartOutlinedIcon,
    href: "/DepositPortal/merchant_reports",
    moduleKey: "Reports",
  },
  {
    title: "Statements",
    icon: SummarizeOutlinedIcon,
    href: "/DepositPortal/merchant_statements",
    moduleKey: "Statements",
  },
  {
    title: "Wallet Logs",
    icon: NotesOutlinedIcon,
    href: "/DepositPortal/wallet_logs",
    moduleKey: "Wallet Logs",
  },
  {
    title: "Teams",
    icon: GroupOutlinedIcon,
    href: "/DepositPortal/teams",
    moduleKey: "Teams",
  },
  {
    title: "Business Setting",
    icon: TuneOutlinedIcon,
    href: "/DepositPortal/bussiness_setting",
    moduleKey: "Buisness Setting",
  },
  {
    title: "Integration",
    icon: IntegrationInstructionsOutlinedIcon,
    href: "/DepositPortal/integration",
    moduleKey: "Integration",
  },
  {
    title: "Change Password",
    icon: VpnKeyOutlinedIcon,
    href: "/DepositPortal/change_password",
    moduleKey: "Change Password",
  },
];

const getMenuItems = () => {
  const accountType = sessionStorage.getItem("accoutType");
  const user_id = sessionStorage.getItem("mer");
  const allowedUsers = ['62', '2176', '2204', '2177', '2179', '2180', '2199', '2168', '2316'];

  return rawMenuItems.filter(item => {
    if ((accountType === '3') &&
      (item.title === "Business Setting" || item.title === "Sub Merchant" || item.title === "Teams")) {
        return false;
    } else if((accountType === '0') &&
      (item.title === "Sub Merchant")){
        return false;
    } else if (!allowedUsers.includes(user_id) && item.title === "Single Payout") {
      return false;
    }
    return true;
  });
};

export default getMenuItems;
